/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export const tableOfContents = [];
export const title = "❄️ Winter break";
export const date = "2022-12-19";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    code: "code",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td"
  }, props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["I passed Software Dev and Capstone, which are probably the most and\nsecond-most time-consuming courses I've taken.\nSoftware Dev made us keep a record (lines of code are ", _jsx(_components.code, {
        children: ".py"
      }), " and ", _jsx(_components.code, {
        children: ".md"
      }), " only):"]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Partner"
          }), _jsx(_components.th, {
            align: "center",
            children: "Codebase"
          }), _jsx(_components.th, {
            align: "center",
            children: "Hours"
          }), _jsx(_components.th, {
            align: "center",
            children: "Weeks"
          }), _jsx(_components.th, {
            align: "center",
            children: "Avg. hours"
          }), _jsx(_components.th, {
            align: "center",
            children: "Avg. additions"
          }), _jsx(_components.th, {
            align: "center",
            children: "Avg. deletions"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Katherine"
          }), _jsx(_components.td, {
            align: "center",
            children: "A"
          }), _jsx(_components.td, {
            align: "center",
            children: "60"
          }), _jsx(_components.td, {
            align: "center",
            children: "5"
          }), _jsx(_components.td, {
            align: "center",
            children: "12"
          }), _jsx(_components.td, {
            align: "center",
            children: "1907"
          }), _jsx(_components.td, {
            align: "center",
            children: "257.4"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Thomas"
          }), _jsx(_components.td, {
            align: "center",
            children: "B"
          }), _jsx(_components.td, {
            align: "center",
            children: "52"
          }), _jsx(_components.td, {
            align: "center",
            children: "2"
          }), _jsx(_components.td, {
            align: "center",
            children: "26"
          }), _jsx(_components.td, {
            align: "center",
            children: "3389"
          }), _jsx(_components.td, {
            align: "center",
            children: "2105.5"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Jojo"
          }), _jsx(_components.td, {
            align: "center",
            children: "B"
          }), _jsx(_components.td, {
            align: "center",
            children: "50"
          }), _jsx(_components.td, {
            align: "center",
            children: "2"
          }), _jsx(_components.td, {
            align: "center",
            children: "25"
          }), _jsx(_components.td, {
            align: "center",
            children: "2674"
          }), _jsx(_components.td, {
            align: "center",
            children: "1914"
          })]
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "And all I got was this unplayable board game :)"
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
